import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AsyncCallback0Arg } from "abweb/utils/callback/AsyncCallback0Arg";

/**
 * Manager registration and firing of destroy listeners.  It is up to the caller to ensure that destroyAll is invoked
 * on teardown of the caller in order to avoid a destroyAll memory leak.
 * TODO - consider renaming to AbDisposerCollection - all this listener nomenclature almost made me not use the class.
 */
export class DestroyListenerMgr {
  constructor() {
    _defineProperty(this, "destroyListeners", new AsyncCallback0Arg());
  }
  // IAsyncDestroyListener

  registerAsyncDestroyListener(listener) {
    let registrar;
    if (typeof listener !== "function") {
      registrar = listener.destroy.bind(listener);
    } else {
      registrar = listener;
    }
    this.destroyListeners.addCallback(registrar);
    return registrar;
  }
  push(disposer) {
    this.destroyListeners.addCallback(disposer);
  }
  removeAsyncDestroyListener(registryEntry) {
    this.destroyListeners.removeCallback(registryEntry);
  }

  // Sync implementations are wrapped in an async fn so that they are ordered correctly
  // with respect to the other listeners.

  registerDestroyListener(syncDestroyListener) {
    let registrar;
    if (typeof syncDestroyListener !== "function") {
      registrar = syncDestroyListener.destroy.bind(syncDestroyListener);
    } else {
      registrar = syncDestroyListener;
    }
    const asyncListener = () => {
      // Note only way it is currently invoked is via destroyAll as async wrapper is only used internally.
      // So rely on destroyAll to clear all syncToAsyncFn entries
      registrar();
      return Promise.resolve();
    };
    this.destroyListeners.addCallback(asyncListener);
    return asyncListener;
  }

  /**
   * Invokes all listeners in reverse order that they were registered(typical 'after' advice ordering),
   * and then removes all listeners after they are invoked.
   */
  async destroyAll() {
    if (this.destroyListeners.listenerCount === 0) {
      return;
    }
    try {
      // CONSERVATIVELY, any error thrown during listener invocation aborts the invocation on the
      // rest of the listeners, and the listeners will ALL be unregistered.
      // Do NOT rely on logging listener errors only, as developers (and customers) never notice logged errors
      // and mem leaks are serious
      await this.destroyListeners.callAllInReverseOrder();
    } finally {
      this.destroyListeners.removeAllCallbacks();
    }
  }
}
//# sourceMappingURL=DestroyListenerMgr.js.map
